import React from 'react';
import { useAppearance } from '../../contexts/AppearanceProvider';

interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon';
}

export const Logo: React.FC<LogoProps> = ({ className = '', variant = 'full' }) => {
  const { isDarkMode } = useAppearance();

  const textColor = isDarkMode ? 'text-white' : 'text-[#1a5fb4]';

  return (
    <div className={`flex items-center ${className}`}>
      <span className={`text-xl font-bold tracking-tight ${textColor}`}>Fintech</span>
    </div>
  );
};
